import React from 'react'
import URLS from '../../config/URLS'
import { Link } from '@abw/badger-ui'
import { Helmet } from 'react-helmet-async'
import { Section } from './Contact'
import { ReactComponent as TrustPayments } from '../../images/misc/TrustPayments.svg'
import { Warning } from '../../ui'

export const Guide = () =>
  <>
    <Helmet>
      <title>LFH - Guide to Hiring</title>
    </Helmet>
    <div className="about">
      <h1 className="mar-t-none mar-b">Guide to hiring</h1>
      <Warning title="Please Note" className="mar-b-2 mar-t-none">
        We don't accept telephone orders so you'll need to place your order on
        this web site.
      </Warning>
      <Section icon="search" title="Find the equipment you want to hire" className="mar-t-2">
        <ImageSection image="search-filters.png" caption="Search filters">
          Pick the equipment you want to hire from the <Link to={URLS.search} text="search page"/>.
          You can use the search filters at the top of the page to help you
          find what you're looking for.
        </ImageSection>
        <p>
          The products matching your selections will be shown below.  Select the hire duration from
          the pull-down menu to see the hire price for that number of days.  Use the other pull-down
          menus at the top of the search results to sort items by name, price, focal length
          or aperture.
        </p>
      </Section>
      <Section icon="search" title="View the product details" className="mar-t-2">
        <ImageSection image="product-page.png" caption="Product page">
          Click on a product card to view the full details.  Each product page contains a chart
          showing the stock availability for the coming months.
        </ImageSection>
        <p>
          Use the green <b>Add</b> button under the product pictures to add the product to your basket.
        </p>
      </Section>
      <Section icon="basket" title="View your basket" className="mar-t-2">
        <p>
          To view the contents of <Link to={URLS.basket.home} text="your basket"/> click
          on the green basket icon in the top right corner of the screen.
        </p>
        <p>
          From the basket you can check the <Link to={URLS.basket.availability} text="availability"/> of
          all the items in your basket.
          The basket page also allows you to remove items or duplicate items in case
          you want two or more of the same lens for some reason.
        </p>
      </Section>
      <Section icon="calendar" title="Enter hire details" className="mar-t-2">
        <p>
          There's a link button at the bottom of the basket page that takes you to the next page
          where you can enter the <Link to={URLS.basket.hire} text="hire details"/>, specifying
          when you want the hire to start and how long you want it to last.
          You can also select the delivery and return options on this page.
        </p>
        <p>
          At this point you'll need to <Link to={URLS.auth.login} text="login"/> if you've
          previously ordered from us, or <Link to={URLS.auth.register} text="register"/> if you're
          a new customer.
          This allows us to retrieve any addresses that you've previously used so you can
          easily select the delivery and/or collection address.
          If you're a new customer or an existing customer with a new address then
          there's the option to add a new address.
        </p>
        <p>
          We can deliver to the billing address, or to a workplace address so long as we
          are able to verify it.  If you want us to delivery to a different address
          then you may have to pay a refundable deposit.
        </p>
      </Section>
      <Section icon="calendar" title="Enter your details" className="mar-t-2">
        <p>
          When you've entered the hire details, click on the button at the bottom
          of the page to take you to the next step where you can enter the remaining
          details to complete your hire.
        </p>
        <p>
          On this page you'll select the billing address (this should be where your payment
          card is registered) and add your telephone number if we don't already have it.
          Feel free to enter multiple telephone numbers (mobile, work, home, etc).
          You can also add any other relevant contact information: your web site, Facebook
          page, and so on.
        </p>
        <p>
          There are a few further questions on this page where we ask you to specify what
          camera(s) you're going to be using the lens(es) with and what you're planning to
          do with them.  This is a sanity check for us so we can make sure you're getting
          the right lenses to work with your existing camera (or the camera you're
          hiring).
        </p>
        <p>
          We don't normally required customers to pay a deposit but in some cases we may
          ask you to (e.g. if you want the equipment delivered to a shoot location
          or temporary accommodation such as a hotel).  There's a checklist to help you decide
          if you might need to pay a deposit.
        </p>
        <p>
          If you have a discount code you can enter it on this page.  In addition we will
          automatically add a 5% discount if you hire 3 or more lenses.
        </p>
        <p>
          The final steps on this page are to accept the <Link to={URLS.about.terms} text="Terms &amp; Conditions"/> and
          optionally, to sign up to receive our email newletters.
        </p>
        <p>
          When everything is complete, click on the <b>Final Confirmation</b> button at the bottom.
        </p>
      </Section>
      <Section icon="checkout" title="Final confirmation" className="mar-t-2">
        <p>
          This is your last chance to review the details of your order.
        </p>
        <p>
          If you're happy with everything then click on the <b>Pay Now</b> button.
          You'll be taken to the Trust Payments site where you can enter your
          credit/debit card details to make the payment.
        </p>
        <p>
          You'll receive an automated acknowledgment of your order. Then when we've
          processed it and checked that everything's OK, you'll receive another email
          (written by a person, not a machine) confirming the details of the hire.
        </p>
        <div className="mar-t-2 trust-payments">
          <TrustPayments/>
        </div>

      </Section>
    </div>
  </>

const ImageSection = ({children}) =>
  <p className="mar-t-none">
    {children}
  </p>

export default Guide